module.exports = __webpack_public_path__ + "img/icon-location.5d65ffd.svg";